import { Component, Inject, OnDestroy, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { ModalDeleteConfigData } from 'src/app/models/modalDeleteConfigData';
import { StationsRepo } from 'src/app/repositories/stations/repo/station-repo';
import { DataAfterCloseDeleteStationConfigModal } from './models/dataAfterCloseDeleteStationConfigModal';


@Component({
    selector: 'app-modal-badges',
    templateUrl: './modal-delete-station-config.component.html',
    styleUrls: ['./modal-delete-station-config.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ModalDeleteStationConfigComponent implements OnInit, OnDestroy {
  loading = false;
  deleteSuccess: any;
  deleteError: any;
  dataAfterClose: DataAfterCloseDeleteStationConfigModal;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: ModalDeleteConfigData,
    private stationRepo: StationsRepo,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.dataAfterClose = new DataAfterCloseDeleteStationConfigModal();
  }

  onClickDelete(): void {
    if (this.data.type === 'opcua') {
      this.deleteStationConfigOpcua();
    } else if (this.data.type === 'gir') {
      this.deleteStationConfigGir();
    }
  }

  deleteStationConfigOpcua() {
    this.loading = true;
    this.stationRepo.deleteConfigurationOpcua(this.data.stationUid, this.data.config.uid).toPromise()
        .then((response: any) => {
          this.afterSuccessDelete();
        })
        .catch((error: any) => {
          this.afterErrorDelete();
        });
  }

  deleteStationConfigGir() {
    this.loading = true;
    this.stationRepo.deleteConfigurationGir(this.data.stationUid, this.data.config.uid).toPromise()
        .then((response: any) => {
          this.afterSuccessDelete();
        })
        .catch((error: any) => {
          this.afterErrorDelete();
        });
  }

  ngOnDestroy() {
  }

  afterSuccessDelete(): void {
    this.loading = false;
    this.deleteSuccess = this.translate.instant('stationConfig.delete.success');
    this.dataAfterClose.successDelete = true;
  }

  afterErrorDelete(): void {
    this.loading = false;
    this.deleteError = this.translate.instant('stationConfig.delete.error');
    this.dataAfterClose.successDelete = false;
  }
}
